var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useQuery } from '@tanstack/react-query';
import { setStoredAiToken } from '../services/aiTokenStorage';
import { requestAiToken } from '../services/aiTokenApi';
// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------
// Token TTL is 15 minutes (900s). Refresh 2 minutes before expiry.
const REFRESH_INTERVAL_MS = 13 * 60 * 1000; // 13 minutes
// ---------------------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------------------
export const AI_TOKEN_QUERY_KEYS = {
    all: ['ai-token'],
    token: () => [...AI_TOKEN_QUERY_KEYS.all, 'current']
};
// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------
export function useAiToken({ enabled }) {
    var _a, _b;
    const query = useQuery({
        queryKey: AI_TOKEN_QUERY_KEYS.token(),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield requestAiToken();
            if (response.error) {
                throw new Error(response.error.message);
            }
            if (!response.data) {
                throw new Error('No token data received');
            }
            return response.data;
        }),
        // Auto-refresh every 13 minutes (token expires in 15 minutes)
        refetchInterval: REFRESH_INTERVAL_MS,
        // Keep token fresh in background
        refetchIntervalInBackground: true,
        // Retry on failure
        retry: 3,
        // Stale time: consider data stale after 12 minutes
        staleTime: 12 * 60 * 1000,
        // Always fetch on mount
        refetchOnMount: true,
        // Persist token to localStorage on success
        onSuccess: (data) => {
            setStoredAiToken(data.token, data.expires_at || null);
        },
        enabled
    });
    return {
        token: ((_a = query.data) === null || _a === void 0 ? void 0 : _a.token) || null,
        expiresAt: ((_b = query.data) === null || _b === void 0 ? void 0 : _b.expires_at) || null,
        isLoading: query.isLoading,
        error: query.error,
        refetch: () => {
            void query.refetch();
        }
    };
}
